import { FC } from 'react';
import SchoolDetail from './SchoolDetail';
import UseSchoolDetail from './UseSchoolDetail';

const SchoolDetailContainer: FC = () => {
  return <SchoolDetail {...UseSchoolDetail()} />;
};

export default SchoolDetailContainer;
